import { FC } from 'react';

type Props = {
	className?: string;
};

const CheckedIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='#2B2B2B'
			className={className}>
			<rect
				x='3'
				y='3'
				width='14'
				height='14'
				rx='3'
				fill='inherit'
			/>
			<path
				d='M2.625 10C2.625 8.09671 2.62633 6.73212 2.76587 5.69419C2.903 4.67424 3.16321 4.06382 3.61351 3.61351C4.06382 3.16321 4.67424 2.903 5.69419 2.76587C6.73212 2.62633 8.09671 2.625 10 2.625C11.9033 2.625 13.2679 2.62633 14.3058 2.76587C15.3258 2.903 15.9362 3.16321 16.3865 3.61351C16.8368 4.06382 17.097 4.67424 17.2341 5.69419C17.3737 6.73212 17.375 8.09671 17.375 10C17.375 11.9033 17.3737 13.2679 17.2341 14.3058C17.097 15.3258 16.8368 15.9362 16.3865 16.3865C15.9362 16.8368 15.3258 17.097 14.3058 17.2341C13.2679 17.3737 11.9033 17.375 10 17.375C8.09671 17.375 6.73212 17.3737 5.69419 17.2341C4.67424 17.097 4.06382 16.8368 3.61351 16.3865C3.16321 15.9362 2.903 15.3258 2.76587 14.3058C2.62633 13.2679 2.625 11.9033 2.625 10Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M7 10.3333L8.875 12L13 8'
				stroke='#FCFCFC'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CheckedIcon;
